"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "5",
  height: "6",
  viewBox: "0 0 5 6"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M4.774 2.577L.593.136a.359.359 0 0 0-.399.019A.49.49 0 0 0 0 .558v4.886a.49.49 0 0 0 .194.402.364.364 0 0 0 .399.02l4.182-2.443A.484.484 0 0 0 5 3a.49.49 0 0 0-.226-.423z"
}));

exports["default"] = _default;